import { Link } from "react-router-dom";
import { Boton } from "../components/Boton";

export function AccesoDenegado() {
  return (
    <div className="flex h-full flex-col items-center justify-center py-24 text-center">
      <p className="text-lg font-semibold text-texto">Acceso denegado</p>
      <p className="mt-1 text-sm text-texto-secundario">No tenés permisos para ver esta sección.</p>
      <Link to="/dashboard" className="mt-4">
        <Boton variante="secundario">Volver al Dashboard</Boton>
      </Link>
    </div>
  );
}
